// extracted by mini-css-extract-plugin
module.exports = {"theme":"#040c7c"};